import { useSnackbar } from 'notistack';
import { ReactNode, useEffect } from 'react';
import { setCurrentFeedback } from 'src/actions/feedbackActions';
import { useAppDispatch, useAppSelector } from 'src/store';

interface FeedbackProviderProps {
  children: ReactNode;
}

export default function FeedbackProvider({ children }: FeedbackProviderProps) {
  const dispatch = useAppDispatch();
  const { feedback, type } = useAppSelector((store) => store.feedback);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (feedback && typeof feedback === 'string') {
      enqueueSnackbar(feedback, {
        variant: type,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        autoHideDuration: 5000,
        // reset feedback reducer
        onExited: () => {
          dispatch(
            setCurrentFeedback({ payload: { feedback: null, type: 'error' } }),
          );
        },
      });
    }
  }, [feedback]);

  return <>{children}</>;
}
